import { apiCall } from "../../utils/api";
import { API_URLS } from "../../constants/api";

// suggestHemisCode — gọi BE trả về mã công trình tiếp theo dạng
// "<prefix>_<khoa>_{yy}.{seq:02d}". Dùng chung cho mọi loại công trình
// (bài báo tạp chí/hội thảo quốc tế/trong nước, sách, triển lãm, giải thưởng,
// hướng dẫn SV NCKH) — xem HemisCodeSuggestField.js. Promise<string>.
export const suggestHemisCode = async (prefix, dashboardYear, departmentId) => {
  try {
    const api = API_URLS.HEMIS_CODE_SUGGEST.suggest(prefix, dashboardYear, departmentId);
    const { response, error } = await apiCall({ ...api });
    if (!error && response?.status === 200 && response.data.success) {
      return response.data.data?.suggestedCode || "";
    }
  } catch (e) {
    // ignore
  }
  return "";
};
